"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyHooks_1 = require("./applyHooks");
function reduxPluginFactory(name, store) {
    return function (router) {
        // sync should return function to deregister hooks
        var removeHooks = applyHooks_1.applyHooks(router, store);
        function dispose(router) {
            removeHooks();
        }
        return { name: name, store: store, dispose: dispose };
    };
}
exports.reduxPluginFactory = reduxPluginFactory;
exports.createReduxPlugin = function (store) {
    return reduxPluginFactory("redux", store);
};
//# sourceMappingURL=reduxPlugin.js.map